import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuControlsOption} from '@Components/contextual-menu/components/contextual-menu-controls-option';
import {GroupSpacing} from '@PosterWhiteboard/page/active-selection.class';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import styles from './group-item-spacing-options.module.scss';
import {useGetNumberOfActiveItems} from '@Hooks/poster-editor/useGetNumberOfActiveItems';
import {useShouldDisableGroupMovementOptions} from '@Hooks/poster-editor/useShouldDisableGroupMovementOptions';

interface GroupItemsSpacingOptionsProps {
  headingComponent?: ReactElement<any> | null;
  optionsContainerClassName?: string;
}

const defaultHeadingComponent = <ContextualMenuHeadingOption id="spacing-alignment-heading-option" text={window.i18next.t('pmwjs_spacing_in_group')} />;

export function GroupItemsSpacingOptions({headingComponent = defaultHeadingComponent, optionsContainerClassName = ''}: GroupItemsSpacingOptionsProps): ReactElement<any> | null {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  const numOfItemsOnPage = useGetNumberOfActiveItems();
  const isLocked = useShouldDisableGroupMovementOptions();

  const onClickHandler = (type: GroupSpacing): void => {
    currentPage?.activeSelection?.onGroupSpacing(type);
  };

  const getHeading = (): ReactElement<any> | null => {
    if (headingComponent !== undefined) {
      return headingComponent;
    }
    return defaultHeadingComponent;
  };

  if (numOfItemsOnPage <= 2) {
    return null;
  }

  return (
    <>
      {getHeading()}
      <ContextualMenuControlsOption
        id="horizontal-alignment-options"
        isCenterAligned
        onClick={onClickHandler}
        containerClassName={optionsContainerClassName}
        data={[
          {
            id: GroupSpacing.HORIZONTAL,
            icon: 'icon-equal-spacing-vertical',
            text: window.i18next.t('pmwjs_horizontal'),
            className: styles.items,
            disabled: isLocked,
          },
          {
            id: GroupSpacing.VERTICAL,
            icon: 'icon-equal-spacing-horizontal',
            text: window.i18next.t('pmwjs_vertical'),
            className: styles.items,
            disabled: isLocked,
          },
        ]}
      />
    </>
  );
}
